import { render, staticRenderFns } from "./FmlCard.vue?vue&type=template&id=48a0b438&scoped=true&"
import script from "./FmlCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FmlCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FmlCard.vue?vue&type=style&index=0&id=48a0b438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0b438",
  null
  
)

export default component.exports